/**
 * An "agent" user is identified by role:
 *   roleID === 13  or  roleName === "AGENT"
 *
 * Agents work the Ocean Import module as their outbound side, so they get
 * Export wording (see importModuleLabels) and land on the import shipment list
 * instead of the dashboard.
 */

export const AGENT_ROLE_ID = 13;
export const AGENT_ROLE_NAME = "AGENT";
export const AGENT_LANDING_PATH = "/import-booking";
export const DEFAULT_LANDING_PATH = "/dashboard";

/**
 * @param {object} authUser
 * @returns {boolean}
 */
export const isAgentUser = (authUser) => {
    if (!authUser || typeof authUser !== "object") return false;

    const roleId = Number(authUser.roleID);
    if (Number.isFinite(roleId) && roleId === AGENT_ROLE_ID) return true;

    const roleName = String(
        authUser.roleName ?? authUser.RoleName ?? authUser.ROLE_NAME ?? "",
    )
        .trim()
        .toUpperCase();
    return roleName === AGENT_ROLE_NAME;
};

/** `setAuthToken` persists the login response, which is a single-element array. */
export const readStoredAuthUser = () => {
    try {
        const stored = JSON.parse(localStorage.getItem("authUser") ?? "null");
        return (Array.isArray(stored) ? stored[0] : stored) || {};
    } catch {
        return {};
    }
};

/**
 * Where to send a user straight after a successful login.
 * @param {object} [authUser] defaults to the user just written to storage
 * @returns {string}
 */
export const getPostLoginPath = (authUser = readStoredAuthUser()) =>
    isAgentUser(authUser) ? AGENT_LANDING_PATH : DEFAULT_LANDING_PATH;
